import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";
import { useMst } from "../../stores/main";

export const TimelineControls = observer(() => {
  const { timelineStore } = useMst();

  const handleFitToView = () => {
    timelineStore.fitToView();
  };

  return (
    <div className="timeline-controls">
      <Tooltip title="Zoom out" placement="top">
        <button
          className="timeline-controls__btn"
          onClick={() => timelineStore.zoomOut()}
        >
          −
        </button>
      </Tooltip>
      <span className="timeline-controls__zoom-level">
        {timelineStore.zoomPercent}%
      </span>
      <Tooltip title="Zoom in" placement="top">
        <button
          className="timeline-controls__btn"
          onClick={() => timelineStore.zoomIn()}
        >
          +
        </button>
      </Tooltip>
      <div className="timeline-controls__divider" />
      <Tooltip title="Fit to workarea" placement="top">
        <button
          className="timeline-controls__btn timeline-controls__btn--fit"
          onClick={handleFitToView}
        >
          Fit
        </button>
      </Tooltip>
    </div>
  );
});
